import React from 'react'
import { Navigate } from 'react-router-dom';
// import useLocalState from "@phntms/use-local-state";
import { useLocalState } from "../util/useLocalStorage";

const PrivateRoute = ({ children }) => {
    // const [jwt,setJwt] = useLocalState("","auth_token");
    const jwt = localStorage.getItem("auth_token");

  return jwt ? children : <Navigate to="/certificates/login"/>;
};

export default PrivateRoute;
